<div class="relative">
  <button
    type="button"
    (click)="toggle()"
    class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-white/15 bg-white/[0.04] text-white/80 text-sm hover:border-[#33E6FF]/60 transition"
  >
    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18" />
    </svg>
    <span>{{ currentLabel() }}</span>
  </button>

  @if (open()) {
    <div class="fixed inset-0 z-40" (click)="toggle()"></div>
    <div class="absolute right-0 z-50 mt-1 w-36 rounded-xl border border-[#33E6FF]/25 bg-[#0B1026] shadow-2xl overflow-hidden py-1">
      @for (l of langs; track l.code) {
        <button
          type="button"
          (click)="pick(l.code)"
          class="w-full text-left px-3 py-2 text-sm hover:bg-white/[0.06] transition"
          [class]="l.code === current() ? 'text-[#33E6FF]' : 'text-white/80'"
        >
          {{ l.label }}
        </button>
      }
    </div>
  }
</div>
